<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="orderInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="区域名称" class='tiny'>
						<el-input style="width:300px;" v-model="orderInfo.areaName" placeholder="请输入区域名称">
						</el-input>
					</el-form-item>
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button type="primary" @click="empty">清空</el-button>
						</template>
					</el-form-item>
					<el-button type="primary" @click="addCarousel">新增</el-button>
				</el-form>

			</header>

		</div>
		<!-- 列表展示 -->
		<el-table :data="expressList" stripe style="width: 100%">
			<el-table-column type="index" align="center" width="90" label="#">
			</el-table-column>
			<el-table-column prop="templateName" label="模板名称" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="areaName" label="区域" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="feeType" label="计费方式" align="center" width="" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					{{scope.row.feeType==1?'按单':'按件'}}
				</template>
			</el-table-column>
			<el-table-column prop="fees" label="快递费" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			
		
			<el-table-column prop="updateTime" label="更新时间" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="" label="操作" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="editialogVisible(scope.row)">编辑</el-button>
					<el-button size="small" type="text" @click="toDelete(scope.row.id)">删除</el-button>
					　　　　
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<!-- <el-pagination style="margin: 20px auto;width:100%;" background :current-page="sliderlist.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="sliderlist.total"
			@size-change="handleSizeChange">
		</el-pagination> -->
		<!-- 新增 -->
		<el-dialog :visible.sync="dialogVisibleSwiper" :title="title" @close="addDialogClose"
			:close-on-click-modal="false">
			<div style="text-align: center">
				<el-form v-model="storeGoodsInfo">
					<el-form-item label="选择区域">
						<el-select clearable filterable v-model="storeGoodsInfo.provinceId" placeholder="请选择省"
							@change="provinceFocus">
							<el-option v-for="item in provinceList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
						<el-select clearable filterable v-model="storeGoodsInfo.cityId" placeholder="请选择市"
							 @change="cityFcus">
							<el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
						<el-select clearable filterable v-model="regionId" placeholder="请选择区"
							 @change="districtFcus">
							<el-option v-for="item in districtList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="计费方式" class="redItem">
						<el-select v-model="storeGoodsInfo.feeType" placeholder="请选择计费方式" style="width: 180px;">
							<el-option :value="1" label="按单">按单</el-option>
							<el-option :value="2" label="按件">按件</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="快递费用" class="redItem">
						<el-input placeholder="请输入快递费" v-model="storeGoodsInfo.fees" style="width: 180px;"></el-input>
					</el-form-item>
					<el-button type="primary" v-if="title=='新增模板区域'" @click="submit">提交</el-button>
					<el-button type="primary" v-else @click="submitClick">提交</el-button>
					
				</el-form>
			</div>
		</el-dialog>
		
	</div>
</template>

<script>
	export default {
		data() {
			
			return {
				title:'',
				page: {
					pageNum: 1,
					pageSize: 10,
				},
				expressList: [],
				orderInfo: {},
				sliderlist:{},
				provinceId:'',
				cityId:'',
				regionId:'',
				storeGoodsInfo: {},
				provinceList: {},
				cityList: {},
				districtList: {},
				dialogVisibleSwiper: false,
				dialogVisibleSwipers: false

			}
		},
		methods: {
			search() { //查询
				this.page.pageNum = 1;
				this.findIndentity()

			},
			empty() { //清空
				this.orderInfo = {}

			},
			addDialogClose() {
				

				this.storeGoodsInfo = {}
			},
			findIndentity() {
				let data = {
					 // pageNum: this.page.pageNum,
					 // pageSize: this.page.pageSize,
					templateId:this.$route.query.id,
					...this.orderInfo
					// name:this.orderInfo.name
				}
				this.$api.storeExpressfeeList(data).then((res) => {
					console.log(res)
					// res.data=JSON.parse(this.$decrypt(res.data)).data
					if (res.state == 'success') {
						this.expressList = res.data.list
						this.sliderlist = res.data
					}
				})

			},
			// 新增
			addCarousel() {
				this.dialogVisibleSwiper = true
				this.title='新增模板区域'
			},

			// 提交
			submit() {
			
				let data = {
					feeType:this.storeGoodsInfo.feeType,
					fees:this.storeGoodsInfo.fees,
					areaId:this.regionId?this.regionId:this.cityId?this.cityId:this.provinceId,
					templateId:this.$route.query.id
				}
							
				this.$api.addstoreExpressfeeList(data).then((res) => {
					console.log(res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.findIndentity()
						this.dialogVisibleSwiper = false
						this.storeGoodsInfo = {}
					} else {
						this.$message.error(res.message);
					}
				})

			},

			// 编辑
			editialogVisible(e) {
				this.$api.findByIdarea(e.areaId).then(res=>{
					console.log(res.data);
				this.storeGoodsInfo =e
				this.storeGoodsInfo.provinceId=res.data[0].id?res.data[0].name:''
				this.storeGoodsInfo.cityId=res.data[1]?res.data[1].name:''
				this.storeGoodsInfo.regionId=res.data[2]?res.data[2].name:''
				this.provinceId=res.data[0].id?res.data[0].id:''
				this.cityId=res.data[1]?res.data[1].id:''
				this.regionId=res.data[2]?res.data[2].id:''
				this.dialogVisibleSwiper = true
				this.title='编辑模板区域'
				if (this.provinceId) {
					this.$api.getAreasFive(this.provinceId).then((res) => {
						if (res.state == 'success') {
							this.cityList = res.data
						}
					})
				}
				if (this.cityId) {
					this.$api.getAreasFive(this.cityId).then((res) => {
						if (res.state == 'success') {
							this.districtList = res.data
						}
					})
				}
				})	
				

			},
			// 编辑修改提交
			submitClick() {
				let data = {
					feeType:this.storeGoodsInfo.feeType,
					fees:this.storeGoodsInfo.fees,
					areaId:this.regionId?this.regionId:this.cityId?this.cityId:this.provinceId,
					id:this.storeGoodsInfo.id
				}
			
				this.$api.editstoreExpressfeeList(data).then((res) => {
				
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisibleSwiper = false
						this.findIndentity();
						this.storeGoodsInfo = {}
						this.regionId=''
					} else {
						this.$message.error(res.message);
					}
				})

			},
			// 删除
			toDelete(e) {
				console.log(e)
				var str = "此操作将删除该模板区域, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					console.log(e)
					this.$api.delstoreExpressfeeList(e).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.findIndentity();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			pageChange(data) {
				this.page.pageNum = data
				this.findIndentity();
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.findIndentity()
			},
			//查询市
			provinceFocus(e) {
				let obj = {};
				obj = this.provinceList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				// this.storeGoodsInfo.province = obj.name
				this.provinceId=obj.id
				this.storeGoodsInfo.province = obj.name
				this.cityId = ""
				this.storeGoodsInfo.cityId = ""
				this.regionId = ""
				this.cityList = {}
				this.districtList = {}
				if (e) {
					this.$api.getAreasFive(e).then((res) => {
						if (res.state == 'success') {
							this.cityList = res.data
						}
					})
				}
			},
			//查询区
			cityFcus(e) {
				let obj = {};
				obj = this.cityList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.cityId=obj.id
				this.storeGoodsInfo.city = obj.name
				this.storeGoodsInfo.regionId = ""
				this.regionId = ""
				this.districtList = {}
				if (e) {
					this.$api.getAreasFive(e).then((res) => {
						if (res.state == 'success') {
							this.districtList = res.data
						}
					})
				}
				
			},
			districtFcus(e) {
				this.regionId = e;
				let obj = {};
				obj = this.districtList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.storeGoodsInfo.area = obj.name
			},
		},




		created() {
			this.$api.getAreasFive(0).then((res) => {
				if (res.state == 'success') {
					this.provinceList = res.data
				}
			})
			this.findIndentity()

		}
	}
</script>

<style>

</style>
